function _addMeToCart1(e, el) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const variantId = parseInt(el.dataset.variantid, 10);
  const hideModal = el.dataset.modalid;
  const modalTarget = hideModal
    ? document.getElementById('QuickAdd-' + hideModal)
    : null;

  if (!variantId) {
    console.error('Error: Variant ID not found');
    return false;
  }

  const formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };

  fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((resp) => {
      if (!resp.ok) {
        throw new Error('Network response was not ok');
      }

      return resp.json();
    })
    .then(() => {
      refreshCartDrawer();
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
        }),
      );
    })
    .catch((err) => {
      console.error('Error: ' + err);
    });

  setTimeout(() => {
    refreshCartDrawer();
    modalTarget?.removeAttribute('open');
  }, 500);

  return false;
}

function refreshCartDrawer() {
  let cartDrawerItems = document.querySelector('cart-drawer-items');
  const cartCount = document.getElementById('cart-count');
  const innerCount = document.getElementById('inner-count');
  const cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawer) {
    if (cartDrawer.classList.contains('is-empty')) {
      cartDrawer.classList.remove('is-empty');
    }

    const emptyDrawerElement = cartDrawer.querySelector('.drawer__inner-empty');
    if (emptyDrawerElement) {
      emptyDrawerElement.remove();
    }

    const cartContentsForm = document.querySelector('.cart__contents');
    if (cartContentsForm) {
      cartContentsForm.style.display = 'block';
    }
  }

  if (!cartDrawerItems) {
    cartDrawerItems = document.createElement('cart-drawer-items');
    const drawerHeader = document.querySelector('.drawer__header');
    if (drawerHeader) {
      drawerHeader.insertAdjacentElement('afterend', cartDrawerItems);
    }
  }

  if (!cartDrawerItems) return;

  cartDrawerItems.onCartUpdate();

  const checkoutButton = document.getElementById('CartDrawer-Checkout');
  checkoutButton?.removeAttribute('disabled');

  if (cartDrawer) {
    cartDrawer.open();
  }

  if (cartCount) {
    cartCount.classList.remove('hidden');
  }

  if (!innerCount) return;

  fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart.js` : '/cart.js')
    .then((res) => res.json())
    .then((res) => {
      innerCount.innerHTML = res.item_count;
    })
    .catch(() => {});
}

function handleQuickAddVariantClick(event) {
  const button = event.target.closest(
    '.quickadd-variant:not(.variant-out):not([disabled])',
  );

  if (button?.dataset.variantid) {
    event.preventDefault();
    event.stopPropagation();
    _addMeToCart1(event, button);
    return;
  }

  // Cached HTML fallback: legacy submit buttons carried data-variantid only.
  const legacyButton = event.target.closest(
    'button[type="submit"][data-variantid]:not([disabled])',
  );
  if (!legacyButton) return;

  event.preventDefault();
  event.stopPropagation();
  _addMeToCart1(event, legacyButton);
}

function handleLegacyCartFormSubmit(event) {
  const form = event.target;
  if (!form?.action?.includes('/cart/add')) return;
  if (form.querySelector('input[name="id"]')) return;

  event.preventDefault();
  event.stopPropagation();

  const submitter =
    event.submitter ||
    form.querySelector('button[data-variantid]:not([disabled])');
  if (submitter?.dataset?.variantid) {
    _addMeToCart1(event, submitter);
  }
}

if (!window.__quickAddLiteInit) {
  window.__quickAddLiteInit = true;
  document.addEventListener('click', handleQuickAddVariantClick, true);
  document.addEventListener('submit', handleLegacyCartFormSubmit, true);
}
